import styled from 'styled-components';
import Icon from '../../../_shared/components/Icon';
import Button from '../../../_shared/components/Button';

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  padding: 0;
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 9px;
  height: 9px;
`;

export const LeftArrowIcon = styled(Icon).attrs({
  icon: 'TR5-Arrow_left'
})`
  width: 20px;
  height: 30px;
  margin-top: 37px;
  margin-right: 20px;
`;

export const StyledCloseButton = styled(Button.Transparent)`
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  height: 25px;
  display: flex;
  align-items: center;
  padding-top: 25px;
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-bottom: 15px;
  margin-left: 45px;
`;

export const Subtitle = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: grey;
  display: flex;
  margin: 0 auto 10px 0;
`;

export const UploadDocumentRow = styled.div`
  margin-bottom: 10px;
  border-spacing: 10px;
  border: 3px solid ${({ theme }) => theme.COLORS.NEUTRAL_5};
  border-radius: 10px;
  padding: 7px;
  margin-left: -0px;
`;

export const UploadedDocumentRowLoading = styled(UploadDocumentRow)`
  height: 37px;
`;

export const UploadedDocumentPreview = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-top: 0;
  margin-bottom: -20px;
  color: ${({ theme }) => theme.COLORS.BLUE};
  text-decoration: underline;
`;

export const GradientDivider = styled.hr`
  background-image: linear-gradient(180deg, grey, white);
  opacity: 30%;
  height: 15px;
  margin-left: -20px;
  margin-right: -20px;
  width: 700px;
  margin-bottom: 10px;
`;

export const SubtitleDivider = styled.hr`
  background-image: linear-gradient(180deg, grey, white);
  opacity: 20%;
  height: 5px;
  margin-left: -20px;
  width: 700px;
  margin-bottom: -10px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MaxFileSizeLabel = styled.p`
  color: grey;
  font-size: small;
`;
export const StyledRowTitle = styled.div`
  font-family: ${({ theme }) => theme.FONT_WEIGHTS.SEMI_BOLD};
  margin-bottom: 6px;
`;
export const StyledSubmitDocumentsButton = styled(Button.Secondary)`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  width: 110px;
  height: 35px;
  background: ${({ theme }) => theme.COLORS.TERTIARY};
  border: none;
  color: white;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 20px;
  margin-right: -440px;
  :hover {
    background: ${({ theme }) => theme.COLORS.DARK_BLUE};
    color: white;
  }
  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.COLORS.NEUTRAL_20};
    border-color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
    opacity: 50%;
  }
`;

export const StyledCancelButton = styled(Button.Secondary)`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  width: 110px;
  height: 35px;
  border: none;
  color: black;
  border-radius: 5px;
  margin-top: 20px;
  :hover {
    cursor: pointer;
    border: none;
  }
`;

export const StyledInformationIcon = styled(Icon).attrs({
  icon: 'TR5-Information_msg'
})`
  height: 18px;
  width: 18px;
  fill: ${({ theme }) => theme.COLORS.INFO};
  display: inline-block;
  margin: 0 0 20px 10px;
`;

export const TitleOwnershipInfoBox = styled.div`
  margin-bottom: 10px;
  border-spacing: 10px;
  border: 2px solid ${({ theme }) => theme.COLORS.INFO};
  border-left: 10px solid ${({ theme }) => theme.COLORS.INFO};
  border-radius: 8px;
  margin-left: -0px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE_UNIT};
`;

export const TitleOwnershipContentWrapper = styled.div`
  display: inline-block;
  width: 85%;
  padding: 10px 0 0 10px;
`;
